// Granular per-user module access for the Task/Flow portal.
// Assignable modules shown in the Team (user management) admin screen.
export const MODULE_CATALOG = [
  { key: 'tasks', label: 'Tasks', group: 'General' },
  { key: 'quotations', label: 'Quotations', group: 'General' },
  { key: 'reports', label: 'Reports', group: 'General' },
  { key: 'store', label: 'Store', group: 'Flow' },
  { key: 'billing', label: 'Billing', group: 'Flow' },
  { key: 'purchase', label: 'Purchase', group: 'Flow' },
  { key: 'logistics', label: 'Logistics', group: 'Flow' },
  { key: 'pendency', label: 'Pendency Report', group: 'Flow' },
  { key: 'analytics', label: 'Sales Analytics', group: 'Flow' },
];

// Backward-compat: derive modules for legacy accounts that predate the `modules` field.
const FLOW_ROLE_MAP = {
  sales_agent: ['pendency', 'analytics'],
  store_user: ['store', 'billing', 'pendency'],
  billing_user: ['billing'],
  purchase_user: ['purchase', 'pendency'],
  logistics_user: ['logistics'],
};

export function effectiveModules(user) {
  if (Array.isArray(user?.modules)) return new Set(user.modules);
  const s = new Set();
  const p = user?.permissions || {};
  if (p.tasks !== false) s.add('tasks');
  if (p.quotations) { s.add('quotations'); s.add('reports'); }
  (FLOW_ROLE_MAP[user?.flow_role] || []).forEach((m) => s.add(m));
  return s;
}

export function can(user, moduleKey) {
  if (user?.role === 'admin') return true;
  return effectiveModules(user).has(moduleKey);
}
